import { render, staticRenderFns } from "./CaminoFormulario.vue?vue&type=template&id=1821906f&"
import script from "./CaminoFormulario.vue?vue&type=script&lang=js&"
export * from "./CaminoFormulario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports